import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './redux/actions';
import ItemDescription from './ItemDescription';
import AuthModal from '../authentification/AuthModal';

export class Item extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
      this.props.actions.getEvent(this.props.id || this.props.match.params.id, { categories: 'True', images: 'True', moderators: 'True', restricted: 'True', prices: 'True'  })
        .catch(err => err && err.reponse && err.response.status === 404 ? this.props.history.replace('/404') : null );
  }

  componentWillReceiveProps(props){
    if(props.id !== this.props.id)
      this.props.actions.getEvent(props.id, { categories: 'True', images: 'True', moderators: 'True', restricted: 'True', prices: 'True'  });
  }

  handleSubcribe(subcribed) {
    if (!subcribed) {
      this.props.actions.addBooking(this.props.id || this.props.match.params.id)
    }
    else {
      this.props.actions.deleteBooking(this.props.id || this.props.match.params.id)
    }
  }

  render() {
    if(!this.props.isAuth) return <AuthModal />

    const event = this.props.item || {};

    return (
        <ItemDescription 
          id={this.props.id || this.props.match.params.id} 
          loading={Object.keys(event).length === 0 || Object.keys(event.event).length === 0 || this.props.event.status.getEvent.pending}
          item={event} />
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isAuth: state.authentification.isAuth,
    event: state.event,
    item: state.event.current_item
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Item);



// WEBPACK FOOTER //
// ./src/features/event/Item.js